export default __webpack_public_path__ + "static/media/exclamation-circle-solid.a29b07d4.svg";